import { render, staticRenderFns } from "./Validacao2Fa.vue?vue&type=template&id=eea71894"
import script from "./Validacao2Fa.vue?vue&type=script&lang=js"
export * from "./Validacao2Fa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports